import { colorStrings } from "@iewcasia/Utilities/variables";
import { OverflowMenuPresentationProps } from "@insite/mobius/OverflowMenu";
import RecursivePartial from "@insite/mobius/utilities/RecursivePartial";

export const overflowMenu: RecursivePartial<{
    defaultProps?: OverflowMenuPresentationProps;
}> = {
    defaultProps: {
        buttonProps: {
            color: "transparent",
            shape: "pill",
        },
        iconProps: {
            color: colorStrings.secondaryMain,
        },
    },
};
